export default __webpack_public_path__ + "static/media/avatar_41.995024fa.png";